import { Theme, Typography } from '@mui/material'
import Stack from '@mui/material/Stack'
import React from 'react'

const SX = {
  fontWeight: 'bold',
  color: (theme: Theme) => theme.palette.grey[600],
}
export const ReturnCancellationModalComponent: React.FC = () => (
  <Stack flexDirection="column" gap={1} padding={2}>
    <Typography variant="h5" sx={SX}>
      Refunds
    </Typography>
    <Typography variant="body1" paragraph>
      All rental transactions are final. If you rent a storage unit/space, you
      are not entitled to a refund for any unused portion of the rental period
      for which you have paid, including prepaid rent. The Term of the Rental
      Agreement shall commence on the date the Rental Agreement is executed and
      shall continue on a month-to-month basis thereafter. The minimum term is
      one month. Manager does not prorate or refund partial month’s rent. Tenant
      covenants with JustLockIt that at the expiration of the term of the Rental
      Agreement, peaceable possession of the storage unit shall be given to
      JustLockIt, in as good condition as it is now, normal wear and tear
      excepted. If Tenant fails or refuses to remove Tenant's personal property
      after the term expires, JustLockIt may determine, in its sole discretion
      that the term has automatically renewed for an additional month.
    </Typography>
    <Typography variant="h5" sx={SX}>
      Shipping
    </Typography>
    <Typography variant="body1" paragraph>
      N/A
    </Typography>
    <Typography variant="h5" sx={SX}>
      Cancellation
    </Typography>
    <Typography variant="body1" paragraph>
      Storage unit/space rental agreement(s) requires client to request
      cancellation via the Client Portal before the 1st of the last month the
      unit(s) are needed.
    </Typography>
  </Stack>
)
